import assetsSystem from '@/shared/assets-system'
import { Color, MeshBasicMaterial, MeshStandardMaterial, Texture } from 'three'
import envmap_physical_pars_fragment from './envmap_physical_pars_fragment'

export default {
  getMaterial(normalMapId: string, diffuseMapId: string, gemColor = 0x000000) {
    const material = new MeshStandardMaterial({
      normalMap: new Texture(),
      map: new Texture(),
      metalness: 1,
      roughness: 0.07,
      envMap: assetsSystem.getTexture('envMap'),
      envMapIntensity: 1,
      vertexColors: false,
      color: 0xffffff
    })

    material.normalMap = assetsSystem.getTexture(normalMapId)
    material.map = assetsSystem.getTexture(diffuseMapId)
    material.userData.shader = {
      uniforms: {
        time: { value: 0 },
        isBloomRender: { value: 0 },
        envMapTint: { value: new Color() }
      }
    }
    if (gemColor > 0) {
      material.defines['USE_CRYSTAL'] = ''
    }
    material.onBeforeCompile = shader => {
      shader.uniforms.gemColor = { value: new Color(gemColor) }
      shader.uniforms.envMapTint = material.userData.shader.uniforms.envMapTint
      shader.uniforms.volumetricNoiseMap = { value: assetsSystem.getTexture('coin-noise') }
      shader.uniforms.isBloomRender = { value: 0 }
      shader.uniforms.time = { value: 0 }
      //frag
      shader.fragmentShader = shader.fragmentShader
        //add uniforms and textures
        .replace(
          'uniform vec3 diffuse;',
          `
            uniform vec3 diffuse;
            uniform vec3 gemColor;
            uniform vec3 envMapTint;
            uniform float isBloomRender;
            uniform float time;
            uniform sampler2D volumetricNoiseMap;
            vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm ) {
              vec3 vSigmaX = dFdx( surf_pos );
              vec3 vSigmaY = dFdy( surf_pos );
              vec3 vN = normalize(surf_norm);    // normalized
              vec3 R1 = cross( vSigmaY, vN );
              float fDet = dot( vSigmaX, R1 );
              return normalize( abs( fDet ) * surf_norm  );
            }
          `
        )
        //override to add a tint color
        //.replace('#include <envmap_physical_pars_fragment>', envmap_physical_pars_fragment)
        //custom diffuse color
        .replace(
          '#include <color_fragment>',
          `
          float isSwatch5 = 1.0-smoothstep(0.0, 0.1,texelColor.r+texelColor.g+texelColor.b);

          float highlightMask = 0.0;
          vec4 noiseColor = vec4(0.0);

          //#if defined( USE_CRYSTAL )
            vec3 normalInTangentSpace = perturbNormalArb(normalize(vViewPosition),vNormal);
            float random = 0.4;
          
            // perlin-isch noise
            vec2 uvMultiplier = vec2(0.5);
            float offsetAmount = texture2D( volumetricNoiseMap, vUv * 0.6 + vec2(random,random)).r;
            vec2 newUV = (vUv * uvMultiplier + vec2(random, random)) + vec2( (normalInTangentSpace.xy + normalInTangentSpace.z*0.2)) * offsetAmount;
            noiseColor = texture2D( volumetricNoiseMap, newUV)*3.0;
            
            highlightMask = smoothstep(0.3,0.6,(noiseColor.r + noiseColor.g + noiseColor.b)*0.3) * isSwatch5 * 0.05;
          //#endif

          vec3 gemPlusNoiseColor = gemColor; //gemroom
          gemPlusNoiseColor *= noiseColor.rgb;
          
          diffuseColor.rgb = texelColor.rgb;
          diffuseColor.rgb += gemPlusNoiseColor * isSwatch5;
        `
        )
        //override metalnessFactor to disable it for crystal material
        .replace(
          '#include <metalnessmap_fragment>',
          `
          float metalnessFactor = metalness * (1.0-isSwatch5);
        `
        )
        //light calculation mix
        .replace(
          'vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;',
          `
          float circularOffset = fract(time*0.2)*6.28;
          float uvX = smoothstep(0.0,0.5,sin(vUv.x*0.6+vUv.y*0.6 + circularOffset));
          float swipeGradient = 0.3 + smoothstep(0.1,0.5,uvX)*smoothstep(0.1,0.5,1.0-uvX);


          float random2 = 0.4 + circularOffset * offsetAmount;
          float noise = texture2D( volumetricNoiseMap, vUv * 0.3 + vec2(random2 + fract(time)*0.9 * vUv.y,random2* vUv.x)).r;
          swipeGradient += smoothstep(0.8,1.0, noise)*100.0;
          
          totalEmissiveRadiance = diffuseColor.rgb * ( 0.3 * swipeGradient + 0.8 * highlightMask * isSwatch5) ;
          vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
        `
        )
        //final color, clamp and control bloom
        .replace(
          '#include <output_fragment>',
          `
          gl_FragColor = vec4( outgoingLight, diffuseColor.a );
          
          gl_FragColor = mix(gl_FragColor,vec4(totalEmissiveRadiance,1.0), isBloomRender);
          //gl_FragColor.rgb = clamp(gl_FragColor.rgb, vec3(0.0), vec3(1.4));
          
        `
        )

      material.userData.shader = shader
    }

    return material
  }
}
